import WModal from '@witkac/bootstrap4-components/src/components/modal.vue';

import { focusMixin } from './focus';

// @vuese
// Mixin modali
export const modalMixin = {
  components: { WModal },
  mixins: [focusMixin('show', true)],
  props: {
    // Czy modal ma być widoczny
    show: { type: Boolean, required: true }
  },
  methods: {
    // @vuese
    // Zamukanie modala
    close() {
      this.$emit('close');
    }
  }
};
